<template>
		<Container class="pt-6 w-full bg-white">
			<PageHeading :title="$t('common.assets')"/>
		</Container>

		<TabLayout :tabs="tabs" sticky>
			<main class="flex-1 overflow-auto">
				<router-view></router-view>
			</main>
		</TabLayout>
</template>

<script>
import TabLayout from "@/Layouts/TabLayout.vue";
import PageHeading from "@/Components/PageHeading.vue";
import Container from "@/Components/Container.vue";

export default {
	name: "AssetsLayout",
	components: {Container, PageHeading, TabLayout},
	computed: {
		tabs() {
			return [
				{
					label: this.$t('layouts.assets.overview'),
					to: {name: 'assets'},
					current: this.$route.name === 'assets'
				},
				{
          label: this.$t('layouts.assets.index'),
					to: {name: 'assets.index'},
					current: this.$route.name === 'assets.index'
				},
				{
					label: this.$t('layouts.assets.recently_viewed'),
					to: {name: 'assets.recently-viewed'},
					current: this.$route.name === 'assets.recently-viewed'
				},
			].filter(t => t.permission === undefined || this.$auth.hasPermission(t.permission))
		}
	},
}
</script>

<style scoped>

</style>